import axiosRetry from "axios-retry";
import axios from "axios";
import backendPointer from "backendPointer";

// Create a new instance of Axios
const axiosInstance = axios.create({
  baseURL: backendPointer(),
  timeout: 4 * 60 * 1000
});

// Apply retry logic to the instance
axiosRetry(axiosInstance, {
  retries: 3, // Set the number of retries
  retryDelay: axiosRetry.exponentialDelay, // Use exponential backoff strategy
  shouldResetTimeout: true, // Reset the timeout on retries,
  shouldRetry: (error) => {
    // Exclude retrying on timeout failures
    return !axiosRetry.isNetworkError(error) && !axiosRetry.isRetryableError(error);
  },
});

// Export the instance
export default axiosInstance;
